import React from "react";

export const MainContext = React.createContext({ });

export const MainProvider = MainContext.Provider;
export const MainConsumer = MainContext.Consumer; 